import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import momentsClient from "../../../api/moments";

const deviceMomentsKey = (clockId: string) => ["deviceMoments", clockId];

export const useDeviceMomentsQuery = (clockId: string) =>
  useQuery({
    queryKey: deviceMomentsKey(clockId),
    queryFn: () => momentsClient.getClockMoments(clockId),
    enabled: !!clockId,
  });

export const useDeleteDeviceMomentMutation = (clockId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (momentId: string) => momentsClient.deleteMoment(momentId),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: deviceMomentsKey(clockId) }),
  });
};
